import { Empty, Pagination, Segmented, Skeleton } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { publicApi } from "../services/api";
import { QueryError, WorkCard } from "../components/Editorial";
import { SEOHead } from "../components/SEOHead";
import { integerParam } from "../utils/period";

export function WaitingRoomPage() {
  const [params, setParams] = useSearchParams();
  const type = ["book", "movie", "series"].includes(params.get("type") ?? "")
    ? params.get("type")!
    : undefined;
  const page = integerParam(params.get("page"), 1, 100000) ?? 1;
  const query = useQuery({
    queryKey: ["public-library-waiting-room", type, page, 24],
    queryFn: () => publicApi.getWaitingRoom({ type, page, page_size: 24 }),
  });
  return (
    <div className="waiting-page">
      <SEOHead
        title="Poczekalnia"
        description="Książki, filmy i seriale, które czekają na swój moment. Zajrzyj do moich planów czytelniczych i filmowych."
        canonicalPath="/waiting-room"
      />
      <div className="page-intro">
        <span className="eyebrow">Jeszcze przede mną</span>
        <h1>Poczekalnia</h1>
        <p>Na następną podróż, spokojny wieczór, wolny weekend.</p>
      </div>
      <div className="library-filters">
        <Segmented
          aria-label="Typ planowanego dzieła"
          value={type ?? "all"}
          onChange={(value) => {
            const next = new URLSearchParams(params);
            next.delete("page");
            if (value === "all") next.delete("type");
            else next.set("type", String(value));
            setParams(next);
          }}
          options={[
            { value: "all", label: "Wszystkie" },
            { value: "book", label: "Książki" },
            { value: "movie", label: "Filmy" },
            { value: "series", label: "Seriale" },
          ]}
        />
      </div>
      {query.isError ? (
        <QueryError retry={() => void query.refetch()} />
      ) : query.isPending ? (
        <Skeleton active paragraph={{ rows: 5 }} />
      ) : (
        <>
          <div className="results-heading">
            <span>{query.data.total} pozycji w planach</span>
          </div>
          {query.data.items.length ? (
            <div className="work-grid library-grid">
              {query.data.items.map((entry) => (
                <WorkCard key={entry.id} entry={entry} planned />
              ))}
            </div>
          ) : (
            <Empty description="Na razie nic tu nie czeka." />
          )}
          {query.data.total > 24 && (
            <Pagination
              className="library-pagination"
              current={page}
              total={query.data.total}
              pageSize={24}
              showSizeChanger={false}
              onChange={(value) => {
                const next = new URLSearchParams(params);
                next.set("page", String(value));
                setParams(next);
              }}
            />
          )}
        </>
      )}
    </div>
  );
}
